export * from './checkbox';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/checkbox/index.js
// module id = 643
// module chunks = 3